/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const partnersSectionStyles = {
  logoContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.background.light,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    aspectRatio: "1 / 1",
  }),
  logo: {
    maxWidth: "55%",
    maxHeight: "35%",
    filter: "grayscale(100%) opacity(0.65)",
  },
};

export default partnersSectionStyles;
